import { render } from "./auditcc.vue?vue&type=template&id=620eb573&scoped=true"
import script from "./auditcc.vue?vue&type=script&lang=js"
export * from "./auditcc.vue?vue&type=script&lang=js"

import "./auditcc.vue?vue&type=style&index=0&id=620eb573&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620eb573"]])

export default __exports__